import React, { useState, useEffect, useContext, useRef } from 'react'
import { getListPersonal, getListadoAutoriza, getListadoPermisos, getListadoTipoPermiso, crearPermisoRRHH, getListadoEstadosPermiso, cancelarPermisos, getListadoPermisosPersonal } from '../../../../API/RRHH/Permisos/PermisosRequests'
import { setDateTimeSQL } from '../../../../Base/Services/FechasService';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import Card from '../../../../Base/Components/Card/Card'
import { AutoComplete, Button, Calendar, ConfirmDialog, Dialog, Dropdown, InputText, Tag, Toast, confirmDialog } from 'primereact';
import AutoCompleteDropdown from '../../../../Base/Components/Form/AutoCompleteDropdown';
import { useForm } from '../../../../Base/Hooks/useForm';
import { toastShow } from '../../../../Base/Services/ToastService';

import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';

// import CrearPermisoPersonal from './CrearPermisoPersonal';

const ListadoPermisosPersonalRRHH = () => {

    const {userAuth} = useContext(AuthContext)


    const toastDialog = useRef(null);
    const toast = useRef(null);

    const [listado, setListado] = useState([]);
    const [loading, setLoading] = useState(false);
    const [personal, setPersonal] = useState([]);
    const [user, setUser] = useState(userAuth);
    const [tipoPermisos, setTipoPermisos] = useState([]);
    const [listAutoriza, setListAutoriza] = useState([]);
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState([]);
    const [estados, setEstados] = useState([]);


    const {values, handleInputChange, setValues, resetForm, setNumber, handleChange, error, setError} = useForm({
        Id: -1,
        Personal: null,
        Tipo: null,
        Observaciones: '',
        Autoriza: null,
        FechaPermiso: new Date()
    });

    const getInitialValues = async () => {

        const a = await getListadoAutoriza(userAuth.Usuario);
        setListAutoriza(a);

        const t = await getListadoTipoPermiso();
        setTipoPermisos(t);

        getInfo();
    }

    const getInfo = async () => {
        const esta = await getListadoEstadosPermiso()
        setLoading(true);
        const per = await getListPersonal(userAuth.Usuario);
        const p = per.map(e => { return { ...e, Concat: e.Codigo + ' - ' + e.Nombre } })
        setPersonal(p)

        const listT = await getListadoPermisosPersonal(userAuth.Usuario);
        const list = listT.map(t => {
            return {
                ...t,
                Permiso: p.filter(e => e.Id === t.TipoPermiso),
                NameEstado: esta.filter(i => i.Id === t.Estado)[0]?.Estado
            }
        })
        setListado(list);
        setLoading(false);
    }

    const showModal = () => {
        setShow(true);
    }

    const onHide = () => {
        resetForm();
        setShow(false);
    }



    const verificarInfo = () => {
        let error = {}
        if (values.FechaPermiso === null || values.FechaPermiso === undefined) {
            error.FechaPermiso = true;
            error.error = true;
        }
        if (values.Personal === null) {
            error.Personal = true;
            error.error = true;
        }
        if (values.Tipo === null) {
            error.Tipo = true;
            error.error = true;
        }
        if (values.Autoriza === null) {
            error.Autoriza = true;
            error.error = true;
        }
        if (values.Observaciones === null) {
            error.Observaciones = true;
            error.error = true;
        }
        setError(error);
        console.log(error);
        return error
    }

    const crearPermiso = async () => {
        const e = verificarInfo();
        if (!e.error) {
            const a = {
                "ID": values?.Id,
                "Correlativo": values?.Correlativo,
                "IdPersonal": values.Personal.Codigo,
                "FechaPermiso": setDateTimeSQL(values.FechaPermiso),
                "TipoPermiso": values.Tipo.Id,
                "Observaciones": values.Observaciones,
                "IdEstado": 1,
                "Autoriza": values.Autoriza.Codigo,
                "FechaReal": null,
                "HoraReal": null,
                "FirmaGA": null,
                "FirmaRH": null,
                "Mail": null
            }
            console.log(a);
            const t = await crearPermisoRRHH(a);
            // console.log(t);
            getInfo();
            onHide();
            toastShow(toast, 'success', 'Permiso creado');
        } else {
            toastShow(toastDialog, 'warn', 'Debe de completar todos los campos.')
        }
    }

    const estadoTemplate = (rowData) => {
        switch (rowData.Estado) {
            case 1:
                return <Tag className='col-12' value={rowData.NameEstado} />
            case 2:
                return <Tag className='col-12' value={rowData.NameEstado} severity='info' />
                break;
            case 3:
                return <Tag className='col-12' value={rowData.NameEstado} severity='success' />
                break;
            case 5:
                return <Tag className='col-12' value={rowData.NameEstado} severity='danger' />
                break;

            default:
                return <Tag className='col-12' value={rowData.NameEstado} style={{ background: '#AAA' }} />
                break;
        }
    }

    const botones = (rowData) => {
        return <Button
            className='p-button-rounded p-button-text'
            icon='pi pi-pencil'
            style={{ marginTop: -3 }}
            onClick={e => {
                console.log(rowData, personal, listAutoriza);
                const p = personal.filter(e => e.Codigo === rowData.Codigo);
                const a = listAutoriza.filter(e => e.Codigo === rowData.Autoriza);
                const t = tipoPermisos.filter(e => e.Id === rowData.TipoPermiso);
                console.log(rowData);
                setShow(true);
                setValues({
                    ...rowData,
                    FechaPermiso: new Date(rowData?.FechaWeb),
                    Autoriza: a.length > 0 ? a[0] : null,
                    Personal: p.length > 0 ? p[0] : null,
                    Tipo: t.length > 0 ? t[0] : null,
                });
            }}
        />
    }

    const columns = [
        {
            header: 'Correlativo',
            field: 'Correlativo',
            className: 'Xsmall'
        },
        {
            header: 'Código',
            field: 'Codigo',
            className: 'Xsmall'
        },
        {
            header: 'Nombre',
            field: 'Nombre',
            className: 'Xlarge',
            Sumary: 'count'
        },
        {
            header: 'Seccion',
            field: 'Seccion',
            className: 'small'
        },
        {
            header: 'TipoPermiso',
            field: 'TipoPermiso',
            // Format: 'Template',
            // filter: true,
            // body: e => {console.log(tipoPermisos.filter(t => t.Id === e.TipoPermiso), e.TipoPermiso); return <span>{}</span> }
            // // {tipoPermisos.filter(t => t.Id === e.TipoPermiso)}
        },
        {
            header: 'Fecha',
            field: 'FechaWeb',
            Format: 'Date'
        },
        {
            header: 'Observaciones',
            field: 'Observaciones',
        },
        // {
        //     header: 'Autoriza',
        //     field: 'NombreAutoriza',
        // },
        {
            header: 'Estado',
            field: 'NameEstado',
            className: 'small',
            Format: 'Template',
            body: estadoTemplate
        },
        {
            header: 'CorreEnviado',
            field: 'CorreoEnviado',
            Format: 'Checkbox',
            className: 'small'
        },
        {
            header: 'FirmaGA',
            field: 'FirmaGA',
            Format: 'Checkbox',
            className: 'small'
        },
        {
            header: 'FirmaRH',
            field: 'FirmaRH',
            Format: 'Checkbox',
            className: 'small',
            onChange: (e, rowData) => { changePermiso(rowData.data, rowData.value) },

        },
        {
            header: '',
            field: 'botones',
            Format: 'Template',
            body: e => e?.Correlativo ? botones(e) : '',
            className: 'small',

        },

    ]

    const table = {
        Columns: columns,
        Data: listado,
        loading: loading,
        selected: selected,
        setSelected: setSelected
    }


    const changePermiso = async (rowData, value) => {
        console.log({ value, rowData })
    }

    const FooterCrear = () => {
        return <div>
            <Button icon='pi pi-times' label='Cancelar' className='p-button-secondary' onClick={onHide} />
            <Button icon='pi pi-save' label='Crear' className='p-button-success' onClick={crearPermiso} />
        </div>
    }


    useEffect(() => {
        getInitialValues();
        setTitlePage('RRHH • Permisos')
    }, [])




    return (
        <div>
            <Toast ref={toast} style={{ zIndex: 50000 }} />
            <ConfirmDialog />
            <Card
                titulo={<div className={'dflex'} style={{ display: 'flex', gap: 10 }}>
                    <h3>Permisos personal</h3>
                    <div style={{ display: 'flex', gap: 10 }}>

                        <Button icon='pi pi-search' onClick={getInfo} />
                        <Button icon='pi pi-plus' onClick={showModal} />
                        <Button icon='pi pi-trash' onClick={() => {
                            confirmDialog({
                                message: `Desea cancelar ${selected.length} permisos?`,
                                header: 'Confirmation',
                                icon: 'pi pi-exclamation-triangle',
                                accept: async () => {
                                    setLoading(true);
                                    const a = cancelarPermisos(selected);
                                    getInfo()
                                },
                                reject: () => { }
                            })
                        }} />
                    </div>

                </div>}
                contenido={<div style={{ height: '90vh', paddingTop: 20 }}>
                    <AgGrid table={table} />
                </div>
                }
            />

                
        </div>
    )
}



export default ListadoPermisosPersonalRRHH